import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import SupportDialogFixed from '../components/SupportDialog.jsx';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

const SupportRequestPage = () => {
  const [open, setOpen] = React.useState(true);
  const { user } = useAuth();
  const navigate = useNavigate();
  const handleClose = () => {
    setOpen(false);
    navigate(-1);
  };
  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Typography variant="h4" gutterBottom textAlign="center" fontWeight="bold">
        Support Request
      </Typography>
      <Box textAlign="center" mb={2}>
        <Typography variant="body1">
          Fill the form below and our support team will reach out.
        </Typography>
      </Box>
      <SupportDialogFixed open={open} onClose={handleClose} presetEmail={user?.email || ''} />
    </Container>
  );
};

export default SupportRequestPage;
